export default "__VITE_ASSET__BubhfpoO__"